import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      // Only append non-empty values
      if (
        params[key] !== "" &&
        params[key] !== undefined &&
        params[key] !== null
      ) {
        queryParams.append(key, params[key].toString());
      }
    });
  }
  return `${baseUrl}?${queryParams.toString()}`;
}

function getLogs(params: {
  limit: number;
  skip: number;
  keyword?: string;
  action?: string;
  entity?: string;
  user?: string;
  country?: string;
  startDate?: string;
  endDate?: string;
}) {
  const baseUrl = "logs";
  const url = buildUrl(baseUrl, params);

  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching logs:", error);
  }
}

function getLog(params: { id: string }) {
  const baseUrl = "logs";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching Log:", error);
  }
}

export { getLogs, getLog };
